import { Company } from "models/Company"

type DetailsListType = {
    company: Company | undefined
}

export default function DetailsList({company}:DetailsListType) {
    return (
        <tbody>
            <tr>
            <th>Markedsnavn</th>
            <td>{company?.name}</td>
            </tr>
            <tr>
            <th>Besøksadresse</th>
            <td>{company?.location?.streetName} {company?.location?.houseNumber}{company?.location?.houseLetter}, {company?.location?.postalCode} {company?.location?.postalArea} </td>
            </tr>
            {company?.postBox !== null && (<tr>
                <th>Postadresse</th>
                <td>Postboks {company?.postBox.number} {company?.postBox.postOffice}, {company?.postBox.postalCode} {company?.postBox.postalArea}</td>
            </tr>)}
        </tbody>
    )
}